import { BaseModel } from "../BaseModel";


class Search {
  searchFields?: string[];
  search?: string ;
}

class BaseFilter<T extends BaseModel> extends Search {
  query?: any;
  fieldFilters?: Partial<T>[];
}

export class GetFilter {
  id?: string | string[];
  populate?: string[];
  fields?: string[];
}

export class CountFilter<T extends BaseModel> extends BaseFilter<T> {}

export class ListFilter<T extends BaseModel> extends BaseFilter<T> {
  page?: number ;
  pageSize?: number ;
  sort?: string| string[];
}

export class FindFilter<T extends BaseModel> extends BaseFilter<T> {
  limit?: number ;
  offset?: number ;
  sort?: string| string[];
}
